const isHttpUrl = (value) => {
  if (typeof value !== "string") return false;
  try {
    const normalized = value.trim();
    const url = new URL(normalized);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch (error) {
    return false;
  }
};

const extractHttpUrl = (value) => {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (isHttpUrl(trimmed)) return trimmed;
  const match = trimmed.match(/https?:\/\/[^")'\s<>]+/i);
  return match ? match[0] : null;
};

const pdfViewerMail = async (url, token) => {
  try {
    const validUrl = extractHttpUrl(url);
    if (!validUrl) {
      return null;
    }

    const validUrlToken = `${validUrl}${token}`;
    // console.log("Valid URL: " + validUrlToken);
    const file = await fetch(validUrlToken);
    const blob = await file.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export default pdfViewerMail;
